module.exports = "https://web-phone.apps.phone.com/static/media/dtmf-star.532480f2.mp3";